module.exports = __webpack_public_path__ + "static/media/loginBackground.cf49dffb.png";